import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

export function useSyncParamsWithRoute(
  params: any,
  setParams: React.Dispatch<React.SetStateAction<any>>,
) {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const page = parseInt(searchParams.get('page') || '') || undefined
    const limit = parseInt(searchParams.get('limit') || '') || undefined
    const tab = searchParams.get('tab') || undefined
    const status = searchParams.get('status') || params.status || undefined
    const queryString = searchParams.get('queryString') || undefined

    // Only update if values have changed
    if (
      params.page !== page ||
      params.limit !== limit ||
      params.tab !== tab ||
      params.status !== status
    ) {
      setParams((prev: any) => ({
        ...prev,
        page,
        limit,
        tab,
        status,
        queryString,
      }))
    }
  }, [location.search, setParams, params.page, params.limit, params])

  const updateRouteParams = (newParams: {
    page?: number
    limit?: number
    tab?: string
    status?: string
    queryString?: string
  }) => {
    const searchParams = new URLSearchParams(location.search)

    if (newParams.page !== undefined) {
      searchParams.set('page', String(newParams.page))
    }

    if (newParams.limit !== undefined) {
      searchParams.set('limit', String(newParams.limit))
    }

    if (newParams.tab !== undefined) {
      searchParams.set('tab', String(newParams.tab))
    }

    if (newParams.status !== undefined) {
      searchParams.set('status', String(newParams.status))
    }

    if (newParams.queryString !== undefined) {
      searchParams.set('queryString', String(newParams.queryString))
    }

    history.replace({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
    })
  }

  return {
    updateRouteParams,
  }
}
